import { render, staticRenderFns } from "./VueGoals.vue?vue&type=template&id=732e644e&scoped=true&"
import script from "./VueGoals.vue?vue&type=script&lang=js&"
export * from "./VueGoals.vue?vue&type=script&lang=js&"
import style0 from "./VueGoals.vue?vue&type=style&index=0&id=732e644e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732e644e",
  null
  
)

component.options.__file = "VueGoals.vue"
export default component.exports